import { PromotionTypes, PromotionData } from '@gongxigames/framework/promotions';

export interface IPromotionLogic {
    type: PromotionTypes;
    getData(): PromotionData;
    isActive(): boolean;
    isExpired(): boolean;
    shouldShowContinuePopup(): boolean;
    hasPromotion(): boolean;
    isNextPromotion(): boolean;
    isLastPromotion(): boolean;
    isEndOfPromotion(): boolean;
    subtractPromotion(): void;
}
